import React, { Component } from 'react';
import { translate } from 'react-i18next';
import ChallengeService from '../../services/ChallengeService.js';
import { connect } from 'react-redux';
import Utils from '../../utils/Utils.js';
import Leaderboards from './Leaderboards.js';
import {initNavbarState} from 'actions/navbar.js';
import {fetchLeaderboards} from 'actions/leaderboards.js';
import {getLeaderboards} from 'reducers/leaderboards.js';

class LeaderboardsContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {busy:false};
        this.onClickLeaderboard = this.onClickLeaderboard.bind(this);
    }

    componentWillMount() {
        this.props.dispatch(initNavbarState({enable:true, mode:'main', title:this.props.t('Leaderboards'), menuEnable:true, backButtonEnable:false, rewardsEnable:true}));
        this.loadData();
    }

    loadData() {
        this.setState({busy:true});
        this.props.loadData()
            .catch((error)=> {
                console.error('ERROR:');
                console.error(error);
            })
            .then(()=>{
                this.setState({busy:false});
            });
    }

    onClickLeaderboard(id) {
        this.props.history.push('/leaderboards/'+id);
    }

    render() {
        return <Leaderboards leaderboards={this.props.leaderboards} 
                             onClickLeaderboard={this.onClickLeaderboard}
                             busy={this.state.busy} />;
    }

}


const mapStateToProps = (state) => {
    return {leaderboards:getLeaderboards(state.leaderboards)};
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadData: () => dispatch(fetchLeaderboards()),
        dispatch: dispatch
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(translate('leaderboards')(LeaderboardsContainer));



// WEBPACK FOOTER //
// ./src/modules/leaderboards/LeaderboardsContainer.js